import { Component } from 'react';
import React from 'react';

import { connect } from 'react-redux'
class Loader extends Component {

     isEditingStillInProgress() {
        let myObject = this.props.isEditingInProgress;
       
        let returnStatus = Object.keys(myObject).filter(function(key, index) {
            return myObject[key] === true
            
            
        });

        if(returnStatus.length === 0)
            return false;
        else
            return true;

        
    }

    render() {
    	let className = 'active';

    	if(this.isEditingStillInProgress() === false) {
    		className='inactive';
    	}
        return (
            <div className={"loader loader--"+className}>
                <div className="loader__content">
                	<div className="spinner"></div>
                	<p>Bezig met verwerken..</p>
                </div>
            </div>
        )
    }
}


// Grab a reference to the current URL. If this is a web app and you are
// using React Router, you can use `ownProps` to find the URL. Other
// platforms (Native) or routing libraries have similar ways to find
// the current position in the app.
function mapStateToProps(state, ownProps) {

    return {
        isEditingInProgress: state.AppReducer.isEditingInProgress
    }
}


export default connect(mapStateToProps)(Loader)


// WEBPACK FOOTER //
// ./src/components/Helpers/Loader.js